import '../../assets/css/GameList.css';
import GameCard from "../../components/GameCard";
import { useNavigate } from "react-router-dom";
import CustomButton from '../../components/CustomButton';
import { useEffect, useState } from 'react';
import { apiHandler } from '../../assets/api';
import { endpoint } from '../../assets/api/endpoint';
import { useSelector } from "react-redux";
import { toast } from 'react-toastify';
import CustomPagination from '../../components/CustomPagination';
import { HashLoader } from 'react-spinners';
import { useGameSocket } from "../gamelist/GameSocketListener";

const MyGame = () => {
    const { accessToken } = useSelector((state) => state.loginInfo);
    const [games, setGames] = useState([]);
    const [showSpinner, setShowSpinner] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const navigate = useNavigate();
    //  const { socketGame } = useGameSocket();

    const fetchGames = async (page = 1) => {
        try {
            const result = await apiHandler({
                url: `${endpoint.JOINED_GAME}?page=${page - 1}`,
                method: "GET",
                authToken: accessToken?.accessToken
            });
            if (!result?.data?.error) {
                setGames(result?.data?.content || []);
                setShowSpinner(false);
                setTotalPages(result.data.totalPages);
                setCurrentPage(result.data.currentPage + 1);
            } else {
                toast.error("Something went wrong");
                setShowSpinner(false);
            }
        } catch (error) {
            toast.error("Something went wrong");
            setShowSpinner(false);
        }
    };

    useEffect(() => {
        fetchGames();
    }, [accessToken  ]);
    // socketGame

    const handlePageChange = (page) => {
        fetchGames(page);
    };

    return (
        !showSpinner ? (
            <>
                <div className='container'>
                    <div className="row row-gap-3 row-gap-sm-0" >
                        {games.length > 0 ? games.map((game) => (
                            <div key={game.id} className="col-lg-6">
                                <GameCard
                                    gameData= {{
                                        gameName: game?.gameName,
                                        courtName: game?.courtName,
                                        startTime: game?.startTime,
                                        endTime: game?.endTime,
                                        courtPrice: game?.courtPrice,
                                        requiredPlayers: game.requiredPlayers,
                                        currentPlayers: game.currentPlayers,
                                        singularity: game.singularity,
                                        status: game.status,
                                        hostName: game.hostName,
                                        level: game.level,
                                        sportName: game.sportName,
                                        gameId: game.gameId
                                    }}
                                />
                            </div>

                        ))
                            :
                            <>
                                <div className=" d-flex align-items-center justify-content-center" style={{ height: '59vh' }}>
                                    <div>
                                        <h3 className="text-center" style={{ fontWeight: '700', color: 'rgb(33 37 41 / 75%)' }}> You haven't joined any games yet  </h3>
                                        <CustomButton buttonText={'Explore games'} className='border mt-2' style={{ width: '152px', height: '48px', borderRadius: '12px', background: '#FF616D', color: '#FFFFFF', marginRight: '22px' }} onClick={() => navigate('/explore')} />
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                    {totalPages > 1 && (
                        <CustomPagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    )}
                </div>
            </>
        ) :
            <div className="d-flex align-items-center justify-content-center" style={{ height: '55vh' }}>
                < HashLoader color="#e48181" />
            </div>
    );
};

export default MyGame;
